import { render, staticRenderFns } from "./ta.vue?vue&type=template&id=0b0fae1e"
import script from "./ta.vue?vue&type=script&lang=js"
export * from "./ta.vue?vue&type=script&lang=js"
import style0 from "./ta.vue?vue&type=style&index=0&id=0b0fae1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports